module.exports = __webpack_public_path__ + "static/tat-17-2d42206b2b4a8cc6147cfe3e6d67503f.jpg";